export default __webpack_public_path__ + "static/2.5.4/media/files.d9e0c6c1.svg";